import { render } from "./SubHeaderGestion.vue?vue&type=template&id=5a8c1c23&scoped=true"
import script from "./SubHeaderGestion.vue?vue&type=script&lang=js"
export * from "./SubHeaderGestion.vue?vue&type=script&lang=js"

import "./SubHeaderGestion.vue?vue&type=style&index=0&id=5a8c1c23&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a8c1c23"

export default script